exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-design-tool-container[data-v-b807546e]{display:block}.insert-text[data-v-b807546e]{display:none}.disabled[data-v-b807546e]{opacity:.4}.element-custom.classification[data-v-b807546e]{margin-top:.175rem;color:var(--fts-default);font-size:85%}", ""]);

// exports
